export enum MCurrencyType {
    NONE = '',
    CAD = 'CAD',
    USD = 'USD',
    EUR = 'EUR'
}
